import cn from "classnames";
import type {Property} from "csstype";

import * as styles from "./SkeletonBox.module.css";

interface IProps {
    className?: string;
    height: Property.Height;
    isText?: boolean;
    width: Property.Width;
    testId?: string;
}

export const SkeletonBox = (props: IProps) => {
    return (
        <div
            className={cn(styles.skeleton, props.isText && styles.text, props.className)}
            data-testid={props.testId}
            style={{height: props.height, width: props.width}}
        />
    );
};
import cn from "classnames";
import type {Property} from "csstype";

import * as styles from "./SkeletonBox.module.css";

interface IProps {
    className?: string;
    height: Property.Height;
    isText?: boolean;
    width: Property.Width;
    testId?: string;
}

export const SkeletonBox = (props: IProps) => {
    return (
        <div
            className={cn(styles.skeleton, props.isText && styles.text, props.className)}
            data-testid={props.testId}
            style={{height: props.height, width: props.width}}
        />
    );
};
